export default __webpack_public_path__ + "static/media/sounds/clpl_model_option_two_Alyx.mp3";